/* eslint-disable no-unused-vars */

import React, { FC } from 'react';
import { RmaInventoryTable } from './components/RmaInventoryTable';
import { RmaToolbar } from './components/RmaToolbar';
import { Page } from 'src/components';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '2em',
    display: 'flex',
    flexDirection: 'column',
    gap: '1em'
  }
}));

export const RmaInventoryView: FC = () => {
  const classes = useStyles();

  return (
    <Page className={classes.root} title="RMA Inventory">
      <RmaToolbar />
      <RmaInventoryTable />
    </Page>
  );
};
